var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1133 12.414C21.1168 13.7339 20.8084 15.0359 20.2133 16.214C19.5078 17.6258 18.4231 18.8132 17.0808 19.6433C15.7385 20.4734 14.1916 20.9134 12.6133 20.914C11.2935 20.9175 9.99146 20.6091 8.81334 20.014L3.11334 21.914L5.01334 16.214C4.41827 15.0359 4.1099 13.7339 4.11334 12.414C4.11395 10.8358 4.55395 9.2889 5.38406 7.9466C6.21417 6.60429 7.4016 5.51961 8.81334 4.81405C9.99146 4.21898 11.2935 3.9106 12.6133 3.91405H13.1133C15.1977 4.02904 17.1664 4.90881 18.6425 6.3849C20.1186 7.861 20.9984 9.8297 21.1133 11.914V12.414Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "assets/media/chat.45da3dcae2d489f89f742f886b79b2cb.svg";
export { ForwardRef as ReactComponent };